import React from "react";
import {FiEdit2, FiTrash2} from "react-icons/fi";
import {TiTick} from "react-icons/ti";
import {Button, Modal, Space, Tooltip, message} from "antd";
import {PlusOutlined} from "@ant-design/icons";
import {createAnnotation} from "@/components/taskManagement/useBoardDetail";
import {getPriorityById} from "@/components/taskManagement/PriorityDropdown";

const TaskActions = ({
                         task,
                         listId,
                         onEditTask,
                         onUpdateTask,
                         onDeleteTask,
                     }) => {
    const formatAnnotationContent = (task, isPreview) => {
        const today = new Date().toLocaleDateString();
        let content = '';
        if (isPreview) {
            content = `<strong>Date:</strong> ${today}\n`;
            content += `<strong>Event Name:</strong> Task: ${task.title}\n`;
            content += `<strong>Category:</strong> Task Status:  ${task.status.name}\n`;
        }

        if (task.description) {
            // content += `<strong>Description:</strong> \n`;
            content += `Task Description: ${task.description}\n`;
        }

        if (task.budget) {
            content += `Budget: ${task.budget}\n`;
        }

        content += `Status: ${task.status.name}\n`;
        content += `Priority: ${getPriorityById(task.priority).name}\n`;
        content += `Due Date: ${new Date(task.due_date).toLocaleDateString()}\n`;

        if (task.attachments.length) {
            content += `Attachment: ${task.attachments.length}\n`;
        }

        return content;
    };

    return (
        <div className="flex items-center">
            <div className="flex items-center px-4">
                <Tooltip title="Edit">
                    <Button
                        type="text"
                        icon={<FiEdit2 className="h-[16px] w-[16px]"/>}
                        onClick={() => onEditTask(task)}
                        className="h-10 w-10 flex items-center justify-center hover:bg-gray-100"
                    />
                </Tooltip>
                <Tooltip title="Delete">
                    <Button
                        type="text"
                        danger
                        icon={<FiTrash2 className="h-[16px] w-[16px]"/>}
                        onClick={() => onDeleteTask(task.id, listId)}
                        className="h-10 w-10 flex items-center justify-center hover:bg-red-50"
                    />
                </Tooltip>

                <Tooltip title="Create Annotation">
                    <Button
                        type="text"
                        icon={<PlusOutlined className="h-[16px] w-[16px]"/>}
                        onClick={async () => {
                            const annotationContent = formatAnnotationContent(task, true);

                            const modalConfig = {
                                title: (
                                    <Space>
                                        <span className="font-medium">Create Annotation?</span>
                                    </Space>
                                ),
                                content: (
                                    <div className="space-y-4">
                                        <div className="flex items-start gap-2">
                                            <p className="text-gray-600">
                                                Creating an annotation helps track task transitions and provides better
                                                workflow visibility
                                            </p>
                                        </div>

                                        <div
                                            className="border font-normal rounded-lg bg-gray-50 p-4 whitespace-pre-line"
                                            dangerouslySetInnerHTML={{__html: annotationContent}}
                                        />
                                    </div>
                                ),
                                okText: 'Create Annotation',
                                cancelText: 'Cancel',
                                okButtonProps: {
                                    className: 'bg-blue-500 hover:bg-blue-600',
                                    size: 'large'
                                },
                                cancelButtonProps: {
                                    size: 'large'
                                },
                                onOk: async () => {
                                    try {
                                        await createAnnotation({
                                            category: `Task Status:  ${task.status.name}`,
                                            event_name: `Task: ${task.title}`,
                                            description: formatAnnotationContent(task, false),
                                            selectedProperties: [""]
                                        });

                                        await onUpdateTask(task.id, {increment_annotation: true});
                                        message.success('Annotation created successfully');
                                    } catch (error) {
                                        console.error("Error creating annotation:", error);
                                        message.error('Failed to create annotation');
                                    }
                                },
                                width: 480,
                                centered: true,
                                maskClosable: false
                            };

                            Modal.confirm(modalConfig);
                        }}
                        className="h-10 w-10 flex items-center justify-center hover:bg-red-50"
                    />
                </Tooltip>
            </div>
        </div>
    );
};

export default TaskActions;
